import { defineMessages } from "react-intl";

const messages = defineMessages({
  apply: {
    id: "resources.resource.actions.apply",
    defaultMessage: "Apply",
    description: "Apply button",
  },
  copyLink: {
    id: "resources.resource.actions.copyLink",
    defaultMessage: "Copy Link",
    description: "Copy Link menu item",
  },
  delete: {
    id: "resources.resource.actions.delete",
    defaultMessage: "Delete{isTrash, select, true { Forever} other {}}",
    description: "Delete menu item",
  },
  deleteConfirm: {
    id: "resources.resource.actions.delete.confirm",
    defaultMessage:
      "Are you sure you want to {isTrash, select, true {permanently delete this file} other {send this file to trash}}?",
    description: "Delete confirm title",
  },
  download: {
    id: "resources.resource.actions.download",
    defaultMessage: "Download",
    description: "Download menu item",
  },
  editLink: {
    id: "resources.resource.actions.editLink",
    defaultMessage: "Edit Link",
    description: "Edit link menu item",
  },
  editLinkTitle: {
    id: "resources.resource.actions.rename.modal.editLink.title",
    defaultMessage: "Edit Link “{name}”",
    description: "Edit link modal title",
  },
  invalidUrl: {
    id: "resources.resource.actions.rename.modal.invalidUrl",
    defaultMessage: "URL is invalid",
    description: "URL field invalid on rename modal",
  },
  moveToFolder: {
    id: "resources.resource.actions.moveToFolder",
    defaultMessage: "Add to Folder",
    description: "Add to Folder menu item",
  },
  moveToFolderLabel: {
    id: "resources.resource.actions.moveToFolder.modal.label",
    defaultMessage: "Add to folder",
    description: "Add to folder modal label",
  },
  moveToFolderSuccess: {
    id: "resources.resource.actions.moveToFolder.success",
    defaultMessage:
      "{resourceName} added to {folderName, select, undefined {folder} other {{folderName}}}",
    description: "Resource added to folder success notification",
  },
  moveToFolderTitle: {
    id: "resources.resource.actions.moveToFolder.modal.title",
    defaultMessage: "Add “{name}” to folder",
    description: "Add to folder modal title",
  },
  pin: {
    id: "resources.resource.actions.pinOrUnpin",
    defaultMessage: "{isPinned, select, true {Unpin} other {Pin}}",
    description: "Pin menu item",
  },
  removeFromFolder: {
    id: "resources.resource.actions.removeFromFolder",
    defaultMessage: "Remove from Folder",
    description: "Remove from Folder menu item",
  },
  removeFromFolderSuccess: {
    id: "resources.resource.actions.removeFromFolder.success",
    defaultMessage: "Resource removed from folder",
    description: "Remove from Folder sucess notification",
  },
  rename: {
    id: "resources.resource.actions.rename",
    defaultMessage: "Rename",
    description: "Rename menu item",
  },
  renamed: {
    id: "resources.resource.actions.rename.success",
    defaultMessage: "Resource renamed",
    description: "Resource renamed success notification",
  },
  renameLabel: {
    id: "resources.resource.actions.rename.modal.label",
    defaultMessage: "New name",
    description: "Rename text field label",
  },
  renameTitle: {
    id: "resources.resource.actions.rename.modal.title",
    defaultMessage: "Rename “{name}”",
    description: "Rename modal title",
  },
  resourceShareSuccess: {
    id: "resources.resource.actions.share.success",
    defaultMessage:
      "{resourceName} shared with {count, plural, one {{userName}} other {{count} people}}",
    description: "Resource renamed success notification",
  },
  restore: {
    id: "resources.resource.actions.restore",
    defaultMessage: "Restore",
    description: "Restore button",
  },
  restoreSuccess: {
    id: "resources.resource.actions.restore.success",
    defaultMessage: "Resource restored",
    description: "Restore success notification",
  },
  share: {
    id: "resources.resource.actions.share",
    defaultMessage: "Share",
    description: "Share menu item",
  },
  shareTitle: {
    id: "resources.resource.share.modal.title",
    defaultMessage: "Share “{name}”",
    description: "Share file menu item title",
  },
  updated: {
    id: "resources.resource.actions.updated.success",
    defaultMessage: "Resource updated",
    description: "Resource updated success notification",
  },
  url: {
    id: "resources.resource.actions.rename.modal.url",
    defaultMessage: "URL",
    description: "URL field on rename modal",
  },
});

export default messages;
